import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Legal.css';

const ConsentPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="legal-page">
            <button onClick={() => navigate(-1)} className="legal-page__back-btn">← Geri Dön</button>

            <h1>AÇIK RIZA BEYANI</h1>

            <p>Fashlytic Anonim Şirketi tarafından sunulan Aydınlatma Metni'ni okudum.</p>

            <ul>
                <li>Yüklediğim fotoğraflarımın yapay zeka teknolojileri ile analiz edilerek <strong>yüz ve vücut biyometrik verilerimin işlenmesine</strong>,</li>
                <li>Sanal deneme hizmetinin oluşturulabilmesi amacıyla verilerimin <strong>yurt dışındaki bulut sunuculara ve yapay zeka servis sağlayıcılarına (server) aktarılmasına</strong>,</li>
                <li>Oluşturulan görsellerin sistemde tekrar kullanım için saklanmasına,</li>
            </ul>

            <p>özgür irademle <strong>ONAY VERİYORUM.</strong></p>
        </div>
    );
};

export default ConsentPage;
